'use strict';

/**
 * Toggle FAQ item
 * @param {jQuery} $faqItem - The FAQ item jQuery element
 */
function toggleFaqItem($faqItem) {
    const $question = $faqItem.find('.faq-question');
    const $answer = $faqItem.find('.faq-answer');
    const $icon = $question.find('.question-icon svg');
    const $horizontalPath = $icon.find('path:nth-child(3)');
    const isExpanded = $question.attr('aria-expanded') === 'true';
    
    if ($answer.length > 0) {
        if (isExpanded) {
            $question.attr('aria-expanded', 'false');
            $answer.css('height', '0px');
            $answer.css('min-height', '0px');
            $horizontalPath.show();
        } else {
            $question.attr('aria-expanded', 'true');
            $answer.css('min-height', $answer[0].scrollHeight + 15 + 'px');
            $horizontalPath.hide();
        }
    }
}

/**
 * Initialize FAQ component
 */
function initFaq() {
    $('.faq-item').each(function() {
        const $faqItem = $(this);
        const $question = $faqItem.find('.faq-question');
        const $answer = $faqItem.find('.faq-answer');
        const $horizontalPath = $question.find('.question-icon svg path:nth-child(3)');

        $question.attr('aria-expanded', 'false');
        $answer.css({
            'min-height': '0px',
            'height': '0px',
            'overflow': 'hidden'
        });
        $horizontalPath.show();
    });

    $('.faq-question').on('click', function() {
        const $faqItem = $(this).closest('.faq-item');
        toggleFaqItem($faqItem);
    });
}

module.exports = {
    initFaq: initFaq
};